import isEmpty from "lodash/isEmpty";
import xorWith from "lodash/xorWith";
import isEqual from "lodash/isEqual"; // todo decide on way of adding to dependencies

export const isArrayEqual = (x, y) => isEmpty(xorWith(x, y, isEqual));
